module.exports = __webpack_public_path__ + "img/empty.e374fae5.png";